import get from 'lodash-es/get';

import config from '../config';

export function configProvider() {
    this.$get = instantiate;

    function instantiate() {
        return new Config();
    }
}

export class Config {
    private config: any;

    constructor() {
        this.loadConfig();
    }

    get debug() {
        return this.config.debug;
    }

    loadConfig() {
        this.config = config;
    }

    get(path) {
        return get(this.config, path);
    }
}
